import { AnimatePresence, useReducedMotion } from 'motion/react';
import React from 'react';

import {
  OptionItemSquareWithSmileIconStyles,
  OptionItemSquareWithSmileStyles,
  OptionItemSquareWithSmileSubtitleStyles,
  OptionItemSquareWithSmileTitleStyles,
} from './OptionItemSquareWithSmile.styles';

export const OptionItemSquareWithSmile: React.FC<{
  title: string;
  subtitle?: string;
  isSelected: boolean;
  onClick: () => void;
  TEST_ID?: string;
  animate?: boolean;
  show: boolean;
  smileImage: string;
}> = ({
  title,
  isSelected,
  onClick,
  TEST_ID,
  animate,
  show,
  smileImage,
  subtitle,
}) => {
  const shouldReduceMotion = useReducedMotion();
  const canAnimate = animate && !shouldReduceMotion;

  if (canAnimate) {
    const scale = isSelected ? 1.03 : 0.97;

    return (
      <AnimatePresence>
        {show && (
          <OptionItemSquareWithSmileStyles
            isSelected={isSelected}
            onClick={onClick}
            data-testid={TEST_ID}
            initial={{
              opacity: 0.5,
              scale: 0.8,
            }}
            animate={{
              opacity: 1,
              scale: scale,
            }}
            exit={{
              opacity: 0.5,
              scale: 0.8,
            }}
            transition={{
              duration: 0.3,
              bounce: 0.5,
            }}
          >
            {smileImage && (
              <OptionItemSquareWithSmileIconStyles>
                <img src={smileImage} alt="smile" />
              </OptionItemSquareWithSmileIconStyles>
            )}
            <OptionItemSquareWithSmileTitleStyles
              isSelected={isSelected}
              variant="title-small"
              align="center"
            >
              {title}
            </OptionItemSquareWithSmileTitleStyles>
            {subtitle && (
              <OptionItemSquareWithSmileSubtitleStyles
                align="center"
                variant="body-small"
                isSelected={isSelected}
              >
                {subtitle}
              </OptionItemSquareWithSmileSubtitleStyles>
            )}
          </OptionItemSquareWithSmileStyles>
        )}
      </AnimatePresence>
    );
  }

  const scale = isSelected ? 1.03 : 1;

  return (
    <OptionItemSquareWithSmileStyles
      isSelected={isSelected}
      onClick={onClick}
      data-testid={TEST_ID}
      initial={{
        scale,
      }}
      animate={{
        scale,
      }}
    >
      {smileImage && (
        <OptionItemSquareWithSmileIconStyles>
          <img src={smileImage} alt="smile" />
        </OptionItemSquareWithSmileIconStyles>
      )}
      <OptionItemSquareWithSmileTitleStyles
        isSelected={isSelected}
        variant="title-small"
        align="center"
      >
        {title}
      </OptionItemSquareWithSmileTitleStyles>
      {subtitle && (
        <OptionItemSquareWithSmileSubtitleStyles
          align="center"
          variant="body-small"
          isSelected={isSelected}
        >
          {subtitle}
        </OptionItemSquareWithSmileSubtitleStyles>
      )}
    </OptionItemSquareWithSmileStyles>
  );
};
